import React from 'react';
import type {
  BookingPurchaseWarning,
  BookingPurchaseWarningModifier,
} from '../BookingPurchaseDialog.types';

function WarningIcon({
  modifier,
}: Readonly<{ modifier?: BookingPurchaseWarningModifier }>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
        fill={modifier === 'waitlist' ? '#0079C4' : '#c43e00'}
      />
    </svg>
  );
}

function WarningRow({ warning }: Readonly<{ warning: BookingPurchaseWarning }>) {
  const { modifier, onClick, message } = warning;
  const modifierClass = modifier ? `warning warning-${modifier}` : 'warning';
  const messageClass = modifier
    ? `warning__message ${modifier}`
    : 'warning__message';

  const body = (
    <>
      <WarningIcon modifier={modifier} />
      <span className={messageClass}>{message}</span>
    </>
  );

  if (onClick) {
    return (
      <button type="button" className={modifierClass} onClick={onClick}>
        {body}
      </button>
    );
  }

  return <div className={modifierClass}>{body}</div>;
}

export function DialogWarnings({
  warnings,
}: Readonly<{ warnings: BookingPurchaseWarning[] }>) {
  return (
    <>
      {warnings.map((warning) => (
        <WarningRow
          key={`${warning.modifier || 'default'}:${warning.message}`}
          warning={warning}
        />
      ))}
    </>
  );
}
